export interface Brand {
  marca: string;
  url_imagen_marca: string | null;
  cantidad_productos_vendidos_2025: number;
  is_featured: boolean;
}

export const marcasProductos: Brand[] = [
  {
    marca: 'DORMAN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DORMAN.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 34933,
  },
  {
    marca: 'KOREA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KOREA.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 21478,
  },
  {
    marca: 'FEBEST',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FEBEST.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 18510,
  },
  {
    marca: 'NAKAMOTO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NAKAMOTO.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 17677,
  },
  {
    marca: 'GSP NORTH AMERICA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/GSP_NORTH_AMERICA.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 15887,
  },
  {
    marca: 'WAGNER QUICKSTOP',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WAGNER_QUICKSTOP.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 13447,
  },
  {
    marca: 'ONNURI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ONNURI.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 12779,
  },
  {
    marca: 'VALVOLINE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/VALVOLINE.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 12220,
  },
  {
    marca: 'DENSO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DENSO.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 11261,
  },
  {
    marca: 'DNJ',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DNJ.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 10178,
  },
  {
    marca: 'PT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PT.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 9721,
  },
  {
    marca: 'BECK/ARNLEY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BECK_ARNLEY.png',
    is_featured: true,
    cantidad_productos_vendidos_2025: 9541,
  },
  {
    marca: 'BANDO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BANDO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8691,
  },
  {
    marca: 'DENSO IRIDIUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DENSO IRIDIUM.jfif',
    is_featured: false,
    cantidad_productos_vendidos_2025: 7956,
  },
  {
    marca: 'MAHLE ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MAHLE_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 7105,
  },
  {
    marca: '555',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/555.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 6032,
  },
  {
    marca: 'MOOG EU',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MOOG_EU.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5691,
  },
  {
    marca: 'BLUE PRINT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BLUE_PRINT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5571,
  },
  {
    marca: 'ECOGARD',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ecogard.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5359,
  },
  {
    marca: 'DORMAN PREMIUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DORMAN PREMIUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5332,
  },
  {
    marca: 'MOOG',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MOOG.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5088,
  },
  {
    marca: 'FAG/RUVILLE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/RUVILLE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4642,
  },
  {
    marca: 'PRESTONE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PRESTONE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4331,
  },
  {
    marca: 'DAYCO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DAYCO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4114,
  },
  {
    marca: 'MOTORAD',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MOTORAD.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3967,
  },
  {
    marca: 'HS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3848,
  },
  {
    marca: 'WALKER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WALKER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3651,
  },
  {
    marca: 'DENSO PLATINUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DENSO PLATINUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3496,
  },
  {
    marca: 'STANDARD/INTERMOTOR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/STANDARD_INTERMOTOR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3489,
  },
  {
    marca: 'TERADA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TERADA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3482,
  },
  {
    marca: 'CHAMPION IRIDIUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CHAMPION_IRIDIUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3474,
  },
  {
    marca: 'TENACITY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TENACITY.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3470,
  },
  {
    marca: 'NATIONAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NATIONAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3414,
  },
  {
    marca: 'NIPPARTS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NIPPARTS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3302,
  },
  {
    marca: 'GUNK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/GUNK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2918,
  },
  {
    marca: 'WAGNER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WAGNER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2806,
  },
  {
    marca: 'EAGLE BHP',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/EAGLE_BHP.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2786,
  },
  {
    marca: 'MONROE OESPECTRUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE_ESPECTRUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2631,
  },
  {
    marca: 'FEBI BILSTEIN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FEBI BILSTEIN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2625,
  },
  {
    marca: 'FAG',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FAG.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2403,
  },
  {
    marca: 'FERODO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FERODO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2380,
  },
  {
    marca: 'MAS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MAS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2378,
  },
  {
    marca: 'AMC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/AMC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2351,
  },
  {
    marca: 'TRAKMOTIVE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TRAKMOTIVE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2244,
  },
  {
    marca: 'KAVO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KAVO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2080,
  },
  {
    marca: 'WESTAR INDUSTRIES',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WESTAR_INDUSTRIES.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2046,
  },
  {
    marca: 'MANDO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MANDO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2012,
  },
  {
    marca: 'NARVA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NARVA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1988,
  },
  {
    marca: 'TRICO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TRICO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1974,
  },
  {
    marca: 'WAGNER LIGHTING',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WAGNER_LIGHTING.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1923,
  },
  {
    marca: 'ORIGINAL ENGINE MANAGEMENT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ORIGINAL_ENGINE_MANAGEMENT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1910,
  },
  {
    marca: 'INA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/INA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1699,
  },
  {
    marca: 'TEZUKA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TEZUKA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1617,
  },
  {
    marca: 'HAN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/han.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1615,
  },
  {
    marca: 'HKT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HKT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1546,
  },
  {
    marca: 'TOYOTA ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOYOTA_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1541,
  },
  {
    marca: 'LIQUI MOLY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/LIQUI_MOLY.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1431,
  },
  {
    marca: 'PARTS-MALL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PARTS_MALL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1349,
  },
  {
    marca: 'DENSO COPPER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DENSO COPPER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1344,
  },
  {
    marca: 'TRANSTEC/CORTECO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TRANSTEC_CORTECO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1332,
  },
  {
    marca: 'MUSASHI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MUSASHI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1280,
  },
  {
    marca: 'LUK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/luk.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1266,
  },
  {
    marca: 'QUICK STEER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/QUICK_STEER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1262,
  },
  {
    marca: 'STELLOX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/STELLOX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1127,
  },
  {
    marca: 'US MOTOR WORKS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/US_MOTOR_WORKS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1082,
  },
  {
    marca: 'MONROE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1001,
  },
  {
    marca: 'MITSUBISHI ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MITSUBISHI_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 940,
  },
  {
    marca: 'FEL-PRO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FEL_PRO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 839,
  },
  {
    marca: 'TOKICO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOKICO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 823,
  },
  {
    marca: 'CHAMPION COPPER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CHAMPION_COPPER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 801,
  },
  {
    marca: 'ERA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ERA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 793,
  },
  {
    marca: 'KOYO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KOYO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 793,
  },
  {
    marca: 'DOKURO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DOKURO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 758,
  },
  {
    marca: 'GMB',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/GMB.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 748,
  },
  {
    marca: 'KYB',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KYB.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 746,
  },
  {
    marca: 'MOTUL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MOTUL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 744,
  },
  {
    marca: 'FIRESTONE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FIRESTONE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 725,
  },
  {
    marca: 'NSO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NSO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 701,
  },
  {
    marca: 'PROJECT PRO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PROJECT_PRO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 701,
  },
  {
    marca: 'PAYEN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PAYEN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 699,
  },
  {
    marca: 'CHAMPION PLATINUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CHAMPION_PLATINUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 682,
  },
  {
    marca: 'TOMITA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOMITA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 678,
  },
  {
    marca: 'TAIHO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TAIHO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 670,
  },
  {
    marca: 'CTR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CTR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 660,
  },
  {
    marca: 'NISSAN ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NISSAN_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 633,
  },
  {
    marca: 'PROSERIES/FEDERAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PROSERIES_FEDERAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 629,
  },
  {
    marca: 'PENNZOIL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PENNZOIL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 628,
  },
  {
    marca: 'WAGNER THERMOQUIET',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WAGNER_THERMOQUIET.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 611,
  },
  {
    marca: 'SENSEN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SENSEN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 609,
  },
  {
    marca: 'MOBIS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MOBIS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 597,
  },
  {
    marca: 'AS-PL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/as-pl.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 585,
  },
  {
    marca: 'BRIDGESTONE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BRIDGESTONE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 583,
  },
  {
    marca: 'GATES',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/GATES.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 574,
  },
  {
    marca: 'MONROE MATIC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE_MATIC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 535,
  },
  {
    marca: 'TOYO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOYO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 500,
  },
  {
    marca: 'FOUR SEASONS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FOUR_SEASONS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 486,
  },
  {
    marca: 'VALEO/PHC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/VALEO_PHC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 485,
  },
  {
    marca: 'TS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 445,
  },
  {
    marca: 'CHAMPION FILTER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CHAMPION_FILTER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 440,
  },
  {
    marca: 'ATLAS LIFT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ATLAS LIFT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 435,
  },
  {
    marca: 'N-ROCKY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/N_ROCKY.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 432,
  },
  {
    marca: 'ANJUN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/anjun.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 432,
  },
  {
    marca: 'NPW',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NPW.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 431,
  },
  {
    marca: 'RAYBESTOS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/RAYBESTOS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 430,
  },
  {
    marca: 'FCS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FCS.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 416,
  },
  {
    marca: 'YOKOZUNA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/YOKOZUNA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 406,
  },
  {
    marca: 'FUJI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FUJI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 402,
  },
  {
    marca: 'LITTLE TREE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/LITTLE TREE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 376,
  },
  {
    marca: 'TOPRAN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOPRAN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 357,
  },
  {
    marca: 'ULTRA POWER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ULTRA_POWER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 352,
  },
  {
    marca: 'NSK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NSK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 317,
  },
  {
    marca: 'ISUZU ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ISUZU_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 301,
  },
  {
    marca: 'BREEZE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BREEZE.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 298,
  },
  {
    marca: '5-826',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/5826.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 288,
  },
  {
    marca: 'EXEDY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/EXEDY_DAIKIN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 283,
  },
  {
    marca: 'TCIC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TCIC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 278,
  },
  {
    marca: 'AISIN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/AISIN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 275,
  },
  {
    marca: 'MONROE MAGNUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE_MAGNUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 275,
  },
  {
    marca: 'NGK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NGK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 259,
  },
  {
    marca: 'WAGNER OEX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WAGNER_OEX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 244,
  },
  {
    marca: 'SEALED POWER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SEALED_POWER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 240,
  },
  {
    marca: 'BLASTER',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 239,
  },
  {
    marca: 'CARDONE SELECT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CARDONE_SELECT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 235,
  },
  {
    marca: 'JOMO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/JOMO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 232,
  },
  {
    marca: 'MITSUBOSHI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MITSUBOSHI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 224,
  },
  {
    marca: 'TAB POLAR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TAB POLAR (1).png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 209,
  },
  {
    marca: 'MAZDA ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MAZDA_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 208,
  },
  {
    marca: 'NPR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NPR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 203,
  },
  {
    marca: 'NTN/SNR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NTN_SNR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 188,
  },
  {
    marca: 'I&R',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/I&R.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 178,
  },
  {
    marca: 'TAMA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TAMA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 169,
  },
  {
    marca: 'CARLSON',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CARLSON.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 168,
  },
  {
    marca: 'PRO SEAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PRO_SEAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 167,
  },
  {
    marca: 'MRC/DEA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DEA_TTPA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 167,
  },
  {
    marca: 'LITTELFUSE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/LITTELFUSE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 162,
  },
  {
    marca: 'LIQUID WRENCH',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/LIQUID_WRENCH.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 159,
  },
  {
    marca: 'MONROE REFLEX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE_REFLEX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 154,
  },
  {
    marca: 'SEIKEN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SEIKEN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 154,
  },
  {
    marca: 'ERISTIC/CADA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ERISTIC_CADA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 150,
  },
  {
    marca: 'QUAKER STATE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/QUAKER_STATE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 143,
  },
  {
    marca: 'LANDSTAR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/LANDSTAR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 143,
  },
  {
    marca: 'AIRTIGHT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/AIRTIGHT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 135,
  },
  {
    marca: 'SUNSONG NORTH AMERICA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/sunsong.PNG',
    is_featured: false,
    cantidad_productos_vendidos_2025: 127,
  },
  {
    marca: 'AJUSA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/AJUSA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 126,
  },
  {
    marca: 'KBC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KBC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 124,
  },
  {
    marca: 'SPECTRA PREMIUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SPECTRA_PREMIUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 121,
  },
  {
    marca: 'JHF',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/JHF.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 119,
  },
  {
    marca: 'GB REMANUFACTURING',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/gb_remanufacturing.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 117,
  },
  {
    marca: 'MEVOTECH',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MEVOTECH.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 113,
  },
  {
    marca: 'NISTO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NISTO.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 111,
  },
  {
    marca: 'SEIWA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SEIWA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 110,
  },
  {
    marca: 'FLAMMA/YEC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FLAMMA_YEC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 105,
  },
  {
    marca: 'PENTIUS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PENTIUS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 103,
  },
  {
    marca: 'MOTORCRAFT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MOTORCRAFT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 103,
  },
  {
    marca: 'EDELMANN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/EDELMANN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 101,
  },
  {
    marca: 'SANKEI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SANKEI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 96,
  },
  {
    marca: 'YSK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/YSK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 95,
  },
  {
    marca: 'MONROE ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 95,
  },
  {
    marca: 'HASAKI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HASAKI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 90,
  },
  {
    marca: 'WALKER EXHAUST SYSTEMS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WALKER_EXHAUST_SYSTEMS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 89,
  },
  {
    marca: 'RECONSTRUIDA KOREA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/korea_reconstruida.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 89,
  },
  {
    marca: 'SCHAEFFLER',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 89,
  },
  {
    marca: 'KOREASTAR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KOREASTAR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 88,
  },
  {
    marca: 'HONDA ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HONDA_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 88,
  },
  {
    marca: 'RAYBESTOS R-LINE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/RAYBESTOS R-LINE.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 88,
  },
  {
    marca: 'WAGNER SEVERE DUTY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WAGNER_SEVERE_DUTY.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 87,
  },
  {
    marca: 'VEMO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/VEMO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 87,
  },
  {
    marca: 'TRICO SENTRY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TRICO SENTRY.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 87,
  },
  {
    marca: 'OSC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/OSC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 81,
  },
  {
    marca: 'KGK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KGK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 80,
  },
  {
    marca: 'CARICO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CARICO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 80,
  },
  {
    marca: 'A1 CARDONE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/A1_CARDONE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 79,
  },
  {
    marca: 'ADVICS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ADVICS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 79,
  },
  {
    marca: 'GM ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/GM_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 77,
  },
  {
    marca: 'BOSCH',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BOSCH.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 76,
  },
  {
    marca: 'HO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 75,
  },
  {
    marca: 'EAGLE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/EAGLE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 74,
  },
  {
    marca: 'TOA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 72,
  },
  {
    marca: 'BERU',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BERU.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 72,
  },
  {
    marca: 'TP',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TP.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 69,
  },
  {
    marca: 'MRK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MRK.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 68,
  },
  {
    marca: 'YEC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/YEC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 67,
  },
  {
    marca: 'TOWA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOWA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 63,
  },
  {
    marca: 'NACHI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NACHI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 62,
  },
  {
    marca: '1-56',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/156.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 60,
  },
  {
    marca: 'ACI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ACI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 59,
  },
  {
    marca: 'RKT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/RKT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 59,
  },
  {
    marca: 'DREIK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DREIK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 57,
  },
  {
    marca: 'HANON',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/hanon.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 57,
  },
  {
    marca: 'TRICO FLEX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TRICO FLEX.jfif',
    is_featured: false,
    cantidad_productos_vendidos_2025: 57,
  },
  {
    marca: 'CENTRIC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CENTRIC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 56,
  },
  {
    marca: 'SUN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SUN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 54,
  },
  {
    marca: 'HI-Q',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HI-Q.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 51,
  },
  {
    marca: 'NISSIN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NISSIN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 51,
  },
  {
    marca: 'HERKO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HERKO.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 51,
  },
  {
    marca: 'PRONTO/DURA INTERNATIONAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PRONTO_DURA_INTERNATIONAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 51,
  },
  {
    marca: 'SBK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SBK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 50,
  },
  {
    marca: 'ROCKY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ROCKY.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 49,
  },
  {
    marca: 'WELLS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WELLS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 48,
  },
  {
    marca: 'TRICO REAR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TRICO REAR.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 47,
  },
  {
    marca: 'CENTURY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CENTURY.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 46,
  },
  {
    marca: 'TAB 5G',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TAB+5G.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 46,
  },
  {
    marca: 'CRUISER ACCESSORIES',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CRUISER_ACCESSORIES.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 43,
  },
  {
    marca: 'ON',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ON.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 42,
  },
  {
    marca: 'SUPER GLUE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SUPER_GLUE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 41,
  },
  {
    marca: 'NORTHWEST TRAIL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NORTHWEST_TRAIL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 38,
  },
  {
    marca: 'ATP',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ATP.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 37,
  },
  {
    marca: 'FORD ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FORD_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 37,
  },
  {
    marca: 'CHAMPION',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CHAMPION.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 37,
  },
  {
    marca: 'KIKI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KIKI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 37,
  },
  {
    marca: 'TRACKONE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/trackone.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 36,
  },
  {
    marca: 'RAYBESTOS ELEMENT3',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/RAYBESTOS ELEMENT3.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 36,
  },
  {
    marca: 'WIX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WIX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 35,
  },
  {
    marca: 'RANCHO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/RANCHOS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 35,
  },
  {
    marca: 'VAICO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/VAICO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 34,
  },
  {
    marca: 'AUTOLITE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/AUTOLITE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 33,
  },
  {
    marca: 'NOK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NOK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 32,
  },
  {
    marca: 'CONTINENTAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CRP_CONTITECH.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 32,
  },
  {
    marca: 'ILJIN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ILJIN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 31,
  },
  {
    marca: 'REACTIVE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/REACTIVE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 31,
  },
  {
    marca: 'HYUNDAI ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HYUNDAI_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 31,
  },
  {
    marca: 'AC DELCO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/AC_DELCO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 31,
  },
  {
    marca: 'J-B WELD',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/JB_WELD.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 31,
  },
  {
    marca: 'THO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/THO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 29,
  },
  {
    marca: 'NDC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NDC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 29,
  },
  {
    marca: 'WJB',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/wjb.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 28,
  },
  {
    marca: '5-825',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/5825.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 28,
  },
  {
    marca: 'DELPHI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DELPHI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 28,
  },
  {
    marca: 'RBI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/RBI.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 28,
  },
  {
    marca: 'FREMAX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FREMAX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 26,
  },
  {
    marca: 'SECO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SECO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 26,
  },
  {
    marca: 'MONROE ADVENTURE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONREO_ADVENTURE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 26,
  },
  {
    marca: 'SAMYUNG',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SAMYUNG.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 26,
  },
  {
    marca: 'TRW',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TRW.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 26,
  },
  {
    marca: 'SUZUKI ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SUZUKI_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 25,
  },
  {
    marca: 'MIYACO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MIYACO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 25,
  },
  {
    marca: 'DIENER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DIENER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 23,
  },
  {
    marca: 'SH',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SH.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 23,
  },
  {
    marca: 'ONE SOURCE/GUARDIAN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ONE_SOURCE_GUARDIAN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 23,
  },
  {
    marca: 'SHIMAHIDE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SHIMAHIDE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 22,
  },
  {
    marca: 'MOOG/PRECISION',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MOOG_PRECISION.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 21,
  },
  {
    marca: 'JS ASAKASHI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/JS_ASAKASHI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 21,
  },
  {
    marca: 'SERINA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SERINA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 20,
  },
  {
    marca: 'MONROE MAX-LIFT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE_MAX_LIFT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 19,
  },
  {
    marca: 'NEW-ERA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NEW_ERA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 19,
  },
  {
    marca: 'AUTO SHACK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/AUTO SHACK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 19,
  },
  {
    marca: 'VORTEX',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 18,
  },
  {
    marca: 'INTERPARTS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/INTERPARTS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 18,
  },
  {
    marca: 'TOP',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOP.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 18,
  },
  {
    marca: 'LAFA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/LAFA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 18,
  },
  {
    marca: 'JFBK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/JFBK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 17,
  },
  {
    marca: 'OSK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/OSK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 17,
  },
  {
    marca: 'OPTIMAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/OPTIMAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 16,
  },
  {
    marca: 'FBJ',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FBJ.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 16,
  },
  {
    marca: 'RIK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/RIK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 16,
  },
  {
    marca: 'SCEPTER',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 15,
  },
  {
    marca: 'TEIKIN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TEIKIN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 15,
  },
  {
    marca: 'AUTO 7',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/AUTO7.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 15,
  },
  {
    marca: 'CARTER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CARTER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 14,
  },
  {
    marca: 'MONROE VAN-MAGNUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE_VAN_MAGNUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 14,
  },
  {
    marca: 'DOOWON',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/doowon.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 14,
  },
  {
    marca: 'KIA ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KIA_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 13,
  },
  {
    marca: 'BENDIX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BENDIX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 13,
  },
  {
    marca: 'ANCHOR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ANCHOR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 13,
  },
  {
    marca: 'NKN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NKN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 12,
  },
  {
    marca: 'ENDURA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ENDURA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 12,
  },
  {
    marca: 'STANT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/STANT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 12,
  },
  {
    marca: 'TIMKEN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TIMKEN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 12,
  },
  {
    marca: 'KFM',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 12,
  },
  {
    marca: '3M',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/3m.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 12,
  },
  {
    marca: 'HAYDEN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HAYDEN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 12,
  },
  {
    marca: 'JBS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/JBS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 11,
  },
  {
    marca: 'NIBK',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 11,
  },
  {
    marca: 'FIC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FIC.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 11,
  },
  {
    marca: 'CHEVROLET ORIGINAL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CHEVROLET_ORIGINAL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 11,
  },
  {
    marca: 'PERFECTION CLUTCH',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PERFECTION_CLUTCH.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 10,
  },
  {
    marca: 'TYC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TYC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 10,
  },
  {
    marca: 'SACHS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SACHS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 9,
  },
  {
    marca: 'NW-IZUMI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NW_IZUMI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 9,
  },
  {
    marca: 'ENERGIZER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ENERGIZER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 9,
  },
  {
    marca: 'ACKOJA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ACKOJAP.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 9,
  },
  {
    marca: 'CLOYES GEAR & PRODUCT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CLOYES_GEAR_&_PRODUCT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 9,
  },
  {
    marca: 'TECHSMART/SMP',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/STANDARD_TRU_TECH.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8,
  },
  {
    marca: 'DASHI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DASHI.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8,
  },
  {
    marca: 'ELRING',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ELRING.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8,
  },
  {
    marca: 'WAGNER LIGHTING TRUVIEW',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WAGNER_LIGHTING_TRUVIEW.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8,
  },
  {
    marca: 'HITACHI',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HITACHI.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8,
  },
  {
    marca: 'TIK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TIK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8,
  },
  {
    marca: 'FUZION',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FUZION.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8,
  },
  {
    marca: 'POWERMAX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/POWERMAX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8,
  },
  {
    marca: 'SKF',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SKF.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 8,
  },
  {
    marca: 'VICTOR REINZ',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/VICTOR_REINZ.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 7,
  },
  {
    marca: 'MONROE DAKAR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE_DAKAR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 7,
  },
  {
    marca: 'TSK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TSK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 7,
  },
  {
    marca: 'AIRTEX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/AIRTEX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 7,
  },
  {
    marca: 'SAFETY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SAFETY.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 6,
  },
  {
    marca: 'BREMBO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BREMBO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 6,
  },
  {
    marca: 'FOREIGN PARTS/OE BRAND',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FOREIGN_PARTS_OE_BRAND.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 6,
  },
  {
    marca: 'SIEMENS',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 6,
  },
  {
    marca: 'VIC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/VIC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 6,
  },
  {
    marca: 'NKK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NKK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5,
  },
  {
    marca: 'DYNATEX',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 5,
  },
  {
    marca: 'CHICAGO PNEOMATIC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CHICAGO_PNEOMATIC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5,
  },
  {
    marca: 'OZIUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/OZIUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5,
  },
  {
    marca: 'BBB/3B',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/bbb_3b.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5,
  },
  {
    marca: 'NTK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NTK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5,
  },
  {
    marca: 'ZUIKO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ZUIKO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5,
  },
  {
    marca: 'NISSHINBO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NISSHINBO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 5,
  },
  {
    marca: 'EXOTICA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/EXOTICA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'ECOGARD SYNTHETIC+',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'TOPDON',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOPDON.jpg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'POWER STOP',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/POWER_STOP.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'PREFERRED COMPONENTS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PREFERRED_COMPONENTS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'TAB AGM STOP & GO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TAB AGM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'BEN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BEN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'ANCO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ANCO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'SUNEX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SUNEX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'EK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/EK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'UNDERGROUND',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/UNDERGROUND.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'MAHLE/CLEVITE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MAHLE_CLEVITE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'KOTEK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KOTEK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'TRICO EXACT FIT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TRICO EXACT FIT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'JET',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/JET.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 4,
  },
  {
    marca: 'CASCO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/casco.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3,
  },
  {
    marca: 'DAIKEN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DAIKEN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3,
  },
  {
    marca: 'XCEL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/XCEL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3,
  },
  {
    marca: 'TS WIPERS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TS_WIPERS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3,
  },
  {
    marca: 'BOSCH RECONSTRUIDA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/bosch_reconstruido.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3,
  },
  {
    marca: 'SKP',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SKP.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3,
  },
  {
    marca: 'PREMIUM GUARD',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/premium_guard.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3,
  },
  {
    marca: 'KAPARS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KAPARS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 3,
  },
  {
    marca: 'T&J',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/T&J.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'ART',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ART.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'PARAUT',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PARAUT.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'DONGSUNG (DS)',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'EUROLITE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/EUROLITE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'TOTO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TOTO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'TRW/LUCAS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TRW_LUCAS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'HELLA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/HELLA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'OPPARTS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/opparts.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'KYOSAN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KYOSAN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'MOC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MOC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'TBK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/TBK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'ATAK',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'PERMATEX',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PERMATEX.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'UNION JAPAN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/UNION_JAPAN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'NBK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NBK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'CHAMPION WIRE & CABLE',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CHAMPION_WIRE_&_CABLE.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'INTERFIL',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/INTERFIL.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'MONROE SENSATRAC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MONROE_SENSATRAC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'BENDIX METAL KING TITANIUM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BENDIX_METAL_KING_TITANIUM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'OBK',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/OBK.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'NEWSUN',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NEWSUN.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'WYNNS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/WYNNS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'FLENNOR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FLENNOR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 2,
  },
  {
    marca: 'KP',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KP.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'FACET',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FACET.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'NAPCO',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NAPCO.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'MANN FILTER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MANN_FILTER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'JURID',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/JURID.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'KDC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/KDC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'SANWA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/SANWA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'REMY',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/REMY.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'FD',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FD.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'NISHIWAKI SEIMETSU (NS)',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NISHIWAKI_SEIMETSU.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'CHAMPION WIPERS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/CHAMPION_WIPERS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'NJA/PROMASTER',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/NJA_PROMASTER.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'IR-ASASHI',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'PIERBURG',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PIERBURG.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'UAC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/uac.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'MOPAR',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MOPAR.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'YRC',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/YRC.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'BLITZ',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BLITZ.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'MBS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/MBS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'DIAMOND',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DIAMOND.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'PHILIPS',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/PHILIPS.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'FRAM',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/FRAM.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'GLOVIS',
    url_imagen_marca: null,
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'DID',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/DID.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'BCA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/BCA.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'ASC INDUSTRIES',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ASC_INDUSTRIES.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'ANZEN XTEND',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ANZEN XTEND.png',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
  {
    marca: 'ABESTA',
    url_imagen_marca:
      'https://allasfileserver.s3.amazonaws.com/varios/aws_catalogo/marcas_proveedores/ABESTA.jpeg',
    is_featured: false,
    cantidad_productos_vendidos_2025: 1,
  },
];
